/**
 * isiZulu: Templates
 *
 * What this file covers: WhatsApp message templates and Meta's approval of them.
 *
 * Tone: Precise. Keep Meta's terms consistent (template, category, approved, rejected, paused). Explain Meta's
 * rules plainly, without blame.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const templates: Catalog = {
  'templates.title': 'Izifanekiso',
  'templates.actions.saveDraft': 'Londoloza uhlaka',
  'templates.columns.category': 'Isigaba',
  'templates.columns.note': 'Inothi',
  'templates.empty': 'Azikho izifanekiso okwamanje.',
  'templates.loadError': 'Ayikwazanga ukulayisha izifanekiso.',
  'templates.modal.delete.title': 'Susa isifanekiso?',
  'templates.toast.submitFailed': 'Ukuhambisa kwehlulekile',
  'templates.view.backToAll': 'Zonke izifanekiso',
  'templates.view.notFound': 'Isifanekiso asitholakali.',
  'templates.view.overview.metadata': 'Imethadatha',
  'templates.view.overview.preview': 'Buka kuqala',
  'templates.view.tabs.components': 'Izingxenye',
  'templates.view.tabs.variables': 'Okuguqukayo',
  'templates.actions.create': 'Dala isifanekiso',
  'templates.showingOf': 'Kukhonjiswa {{count}} kwangu-{{total}}',
  'templates.note.underReview': 'Kubuyekezwa yi-Meta.',
  'templates.view.overview.businessName': 'Ibhizinisi lakho',
  'templates.view.overview.composer': 'Bhala umyalezo',
  'templates.header.label': 'Isihloko',
  'templates.header.format.none': 'Asikho isihloko',
  'templates.header.format.text': 'Umbhalo',
  'templates.header.format.image': 'Isithombe',
  'templates.header.format.video': 'Ividiyo',
  'templates.header.format.document': 'Idokhumenti'
};

export default templates;
